<template>
  <div>
    <label class="file-select">
      <div class="select-button btn btn-sm btn-outline-info">
        <span v-if="value">Wybrany plik: {{value.name}}</span>
        <span v-else>Wybierz plik</span>
      </div>
      <input type="file" @change="(e) => handleFileChange(e.target.files[0])" :accept="accept" />
    </label>
    <button
      class="btn btn-sm btn-outline-danger remove-button"
      v-if="value"
      @click="handleFileChange(null)"
    >
      <font-awesome-icon icon="trash" class="fa-fw"></font-awesome-icon>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: File,
    accept: String
  },

  methods: {
    handleFileChange(file) {
      this.$emit("input", file);
    }
  }
};
</script>

<style scoped>
button.remove-button {
  display: inline-block;
}
.file-select > .select-button {
  /* padding: 0.5rem; */
  border-radius: 0.3rem;
  text-align: center;
  margin-right: 5px;

  cursor: pointer;
}

.file-select > input[type="file"] {
  display: none;
}
</style>